/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { HiDocumentAdd } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import Loading from "../../../components/shared/loading/Loading";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";

const CareerCreate = () => {
  const { careersApi } = apiPath;
  const { aboutUsCareerList } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "title",
      type: "Text",
      name: "title",
      required: true,
    },
    {
      elementType: "input",
      label: "detail title",
      type: "Text",
      name: "detail_title",
      required: false,
    },
    {
      elementType: "input",
      label: "sub title",
      type: "Text",
      name: "sub_title",
      required: false,
    },
    {
      elementType: "input",
      label: "date",
      type: "Text",
      name: "date",
      required: false,
    },
    {
      elementType: "textField",
      label: "description",
      type: "Text",
      name: "description",
      required: false,
    },
    {
      elementType: "select",
      label: "Job Status",
      type: "select",
      name: "status",
      options: ["active", "hired", "hidden"],
      required: false,
    },
  ];

  const update = async (data) => {
    data.identifier = data.title;
    const res = await updateData(careersApi, data, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + aboutUsCareerList;
      }, 600);
    }
  };

  return (
    <div>
      <div className="md:pl-8 mt-4 mb-8">
        <h1 className="font-oswald font-bold text-2xl -mb-10 uppercase">
          <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new career
        </h1>
      </div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default CareerCreate;
